
export type MessageSenderType = 'user' | 'seller' | 'ai';
export type MessageTone = 'legal' | 'polite' | 'aggressive' | 'friendly' | 'custom';
export type MessageStatus = 'sent' | 'delivered' | 'read';

// Enhanced message metadata
export interface MessageMetadata {
  sentiment?: string;
  suggestedTone?: MessageTone;
  exchangeCount?: number;
  responseTimeHours?: number;
  referenceId?: string;
  refundApproved?: boolean;
  tone?: MessageTone;
  customInstructions?: string;
  relatedMessageId?: string; // Track which message is being replaced/regenerated
}

// Interface for UI representation of a message
export interface Message {
  id: string;
  type: MessageSenderType;
  content: string;
  timestamp: Date;
  status?: MessageStatus;
  tone?: MessageTone;
  isRegenerated?: boolean;
  metadata?: MessageMetadata;
  relatedToMessageId?: string; // Link to original message
  version?: number; // Message version
}

// Interface for database representation of a message
export interface DBMessage {
  id: string;
  refund_request_id: string;
  sender_type: MessageSenderType;
  content: string;
  created_at: string;
  updated_at?: string;
  status?: MessageStatus;
  tone?: MessageTone;
  is_regenerated?: boolean;
  metadata?: MessageMetadata;
  related_to_message_id?: string; // Link to original message
  version?: number; // Message version
}

// Utility function to convert from database to UI format
export const mapDBMessageToUIMessage = (dbMessage: DBMessage): Message => ({
  id: dbMessage.id,
  type: dbMessage.sender_type,
  content: dbMessage.content,
  timestamp: new Date(dbMessage.created_at),
  status: dbMessage.status,
  tone: dbMessage.tone,
  isRegenerated: dbMessage.is_regenerated || false,
  metadata: dbMessage.metadata,
  relatedToMessageId: dbMessage.related_to_message_id,
  version: dbMessage.version || 1
});
